import { useMutation } from '@tanstack/react-query';
import { publicProposalApi } from '@/api/commercial/public-proposal';

export function useSendOtp() {
  return useMutation({
    mutationFn: (token: string) => publicProposalApi.sendOtp(token),
  });
}
